module App.Interfaces {
    export interface IAppRootScope extends ng.IRootScopeService {
        title: string;
        form: ng.IFormController;
        loading: boolean;
        isPageValid: boolean;
    }
}